export default function Text(props: {
  children: any;
  className?: string;
  size?: "XS" | "S" | "M" | "L";
  fontWeight?: "normal" | "semibold" | "bold";
}) {
  const fontSize = {
    XS: "text-xs",
    S: "text-sm",
    M: "text-base",
    L: "text-lg",
  };
  const fontWeight = {
    normal: "font-normal",
    semibold: "font-semibold",
    bold: "font-bold",
  };
  return (
    <span
      className={`${fontSize[props.size || "M"]} ${
        fontWeight[props.fontWeight || "normal"]
      } ${props.className ? props.className : ""}`}
    >
      {props.children}
    </span>
  );
}
